// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breeze .show-mini-sidebar .main-content {
  margin-left: 40px;
}

app-side-nav {
  position: absolute;
}

.sidebar {
  flex-basis: 200px;
  border-bottom: 0 none;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.46);
  z-index: 10;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.sidebar .wfm-sidebar-menu-container li {
  border-left: 5px solid #B8C4CC;
  padding-left: 16px;
  line-height: 42px;
}
.sidebar .wfm-sidebar-menu-container li.nav-item {
  background-color: #F2F5F7;
  height: 44px;
}
.sidebar .wfm-sidebar-menu-container li.nav-item a {
  padding-top: 0;
  padding-bottom: 0;
  color: #000000;
}
.sidebar .wfm-sidebar-menu-container li.nav-item a span {
  margin-left: 10px;
  display: inline-block;
}
.sidebar .wfm-sidebar-menu-container li.nav-item a.active svg {
  fill: #008CCB;
}
.sidebar .wfm-sidebar-menu-container li.nav-item a.active .item-label {
  color: #0094D1;
}
.sidebar.show-mini-sidebar {
  flex-basis: 60px;
}
.sidebar.show-mini-sidebar .wfm-sidebar-menu-container li {
  padding-left: 16px;
}
.sidebar.show-mini-sidebar .wfm-sidebar-menu-container li.nav-item .item-label {
  display: none;
}

.top-bar {
  background-image: linear-gradient(180deg, #009EDA, #007CBE);
  padding: 0px 20px;
  line-height: 34px;
}
.top-bar .app-name {
  vertical-align: middle;
  display: inline-block;
  color: white;
  font-size: 18px;
  font-family: "Open Sans Regular", "Helvetica Neue", sans-serif;
}

.nav-item.show,
.nav-item:hover {
  background: #007fba;
}

.nav-item.dropdown {
  font-size: 14px;
}

.dropdown-menu {
  border-radius: 0;
  margin-top: 0;
  width: 180px;
  padding: 2px 0 0 0;
  border: 0;
  font-size: 14px;
  background: #006fa1;
  color: #FFF;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
}
.dropdown-menu .dropdown-item {
  background: #007fba;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dropdown-menu .dropdown-item:hover {
  background: #1C639C;
}
.dropdown-menu .dropdown-item.disabled {
  color: lightgrey;
  opacity: 0.65;
}

.navbar-dark .navbar-nav .nav-link {
  color: #FFF;
  padding-left: 21px;
  padding-right: 37px;
}
.navbar-dark .navbar-nav .nav-link .dropdown-item:hover {
  background: #1C639C;
}

.show.nav-item.dropdown {
  width: 180px;
}

.show .dropdown-toggle {
  text-align: left;
}

.dropdown-toggle span {
  max-width: 122px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
}

.dropdown-toggle::after {
  vertical-align: middle;
  border: 0;
  font-size: 10px;
  content: "\\e919";
  font-family: "icomoon";
  position: absolute;
  top: 8px;
  right: 20px;
}

.navbar-brand {
  padding-left: 24px;
}

.app-content {
  overflow: hidden;
}

.main-content {
  background-color: #E1EAF2;
  position: relative;
  margin-left: 0px;
}

.with-top-bar .main-content {
  padding-left: 230px;
  padding-right: 0;
  margin-left: 0;
  transition: all 0.2s ease-in-out 0s;
}

.with-top-bar.show-mini-sidebar .main-content {
  margin-left: 0px;
  padding-left: 60px;
  padding-right: 0;
}

.content-wrapper {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.content-wrapper.with-top-bar {
  top: 50px;
}

.help-icon {
  color: white;
  font-size: 20px;
  padding-top: 8px;
  cursor: pointer;
}

.dropdown-user a {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/app.component.scss"],"names":[],"mappings":"AAEI;EACE,iBAAA;ACDN;;ADKA;EACE,kBAAA;ACFF;;ADIA;EACE,iBAAA;EACA,qBAAA;EACA,yCAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ACDF;ADGI;EACE,8BAAA;EACA,kBAAA;EACA,iBAAA;ACDN;ADEM;EACE,yBAAA;EACA,YAAA;ACAR;ADCQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;ACCV;ADAU;EACE,iBAAA;EACA,qBAAA;ACEZ;ADCY;EACE,aAAA;ACCd;ADCY;EACE,cAAA;ACCd;ADME;EACE,gBAAA;ACJJ;ADMM;EACE,kBAAA;ACJR;ADMU;EACE,aAAA;ACJZ;;ADYA;EACE,2DAAA;EACA,iBAAA;EACA,iBAAA;ACTF;ADUE;EACE,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,8DAAA;ACRJ;;ADYA;;EAEE,mBAAA;ACTF;;ADWA;EACE,eAAA;ACRF;;ADUA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;ACPF;ADSE;EACE,mBAAA;EACA,eAAA;EAIA,uBAAA;EACA,gBAAA;ACVJ;ADMI;EACE,mBAAA;ACJN;ADUE;EACE,gBAAA;EACA,aAAA;ACRJ;;ADYA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;ACTF;ADUE;EACE,mBAAA;ACRJ;;ADWA;EACE,YAAA;ACRF;;ADUA;EACE,gBAAA;ACPF;;ADSA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;ACNF;;ADQA;EACE,sBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;ACLF;;ADOA;EACE,kBAAA;ACJF;;ADOA;EACE,gBAAA;ACJF;;ADQA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;ACLF;;ADQA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;ACLF;;ADOA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;ACJF;;ADQA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;ACLF;ADME;EACE,SAAA;ACJJ;;ADQA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACLF;;ADOA;EACE,YAAA;ACJF","sourcesContent":[".breeze {\n  .show-mini-sidebar {\n    .main-content {\n      margin-left: 40px;\n    }\n  }\n}\napp-side-nav{\n  position: absolute;\n}\n.sidebar {\n  flex-basis: 200px;\n  border-bottom: 0 none;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.46);\n  z-index: 10;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  .wfm-sidebar-menu-container {\n    li {\n      border-left: 5px solid #B8C4CC;\n      padding-left: 16px;\n      line-height: 42px;\n      &.nav-item {\n        background-color: #F2F5F7;\n        height: 44px;\n        a {\n          padding-top: 0;\n          padding-bottom: 0;\n          color: #000000;\n          span {\n            margin-left: 10px;\n            display: inline-block;\n          }\n          &.active {\n            svg {\n              fill: #008CCB;\n            }\n            .item-label {\n              color: #0094D1;\n            }\n          }\n        }\n      }\n    }\n  }\n  &.show-mini-sidebar {\n    flex-basis: 60px;\n    .wfm-sidebar-menu-container {\n      li {\n        padding-left: 16px;\n        &.nav-item {\n          .item-label {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n.top-bar {\n  background-image: linear-gradient(180deg, #009EDA, #007CBE);\n  padding: 0px 20px;\n  line-height: 34px;\n  .app-name {\n    vertical-align: middle;\n    display: inline-block;\n    color: white;\n    font-size: 18px;\n    font-family: \"Open Sans Regular\", \"Helvetica Neue\", sans-serif\n  }\n}\n\n.nav-item.show,\n.nav-item:hover {\n  background: #007fba;\n}\n.nav-item.dropdown {\n  font-size: 14px;\n}\n.dropdown-menu {\n  border-radius: 0;\n  margin-top: 0;\n  width: 180px;\n  padding: 2px 0 0 0;\n  border: 0;\n  font-size: 14px;\n  background: #006fa1;\n  color: #FFF;\n  box-shadow: 0px 3px 15px rgba(0,0,0,0.3);\n\n  .dropdown-item {\n    background: #007fba;\n    cursor: pointer;\n    &:hover {\n      background: #1C639C;\n    };\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  .dropdown-item.disabled {\n    color: lightgrey;\n    opacity: 0.65;\n  }\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: #FFF;\n  padding-left: 21px;\n  padding-right: 37px;\n  .dropdown-item:hover {\n    background: #1C639C;\n  }\n}\n.show.nav-item.dropdown {\n  width: 180px;\n}\n.show .dropdown-toggle {\n  text-align: left;\n}\n.dropdown-toggle span{\n  max-width: 122px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  vertical-align: top;\n}\n.dropdown-toggle::after {\n  vertical-align: middle;\n  border: 0;\n  font-size: 10px;\n  content: \"\\e919\";\n  font-family: \"icomoon\";\n  position: absolute;\n  top: 8px;\n  right: 20px;\n}\n.navbar-brand {\n  padding-left: 24px;\n}\n\n.app-content {\n  overflow: hidden;\n\n}\n\n.main-content {\n  background-color: #E1EAF2;\n  position: relative;\n  margin-left: 0px;\n}\n\n.with-top-bar  .main-content{\n  padding-left: 230px;\n  padding-right: 0;\n  margin-left: 0;\n  transition: all 0.2s ease-in-out 0s;\n}\n.with-top-bar.show-mini-sidebar  .main-content{\n  margin-left: 0px;\n  padding-left: 60px;\n  padding-right: 0;\n}\n\n\n.content-wrapper {\n  overflow: hidden;\n  position: absolute;\n  top:0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  &.with-top-bar {\n    top: 50px;\n  }\n}\n\n.help-icon {\n  color: white;\n  font-size: 20px;\n  padding-top: 8px;\n  cursor: pointer;\n}\n.dropdown-user a{\n  color:white;\n}\n",".breeze .show-mini-sidebar .main-content {\n  margin-left: 40px;\n}\n\napp-side-nav {\n  position: absolute;\n}\n\n.sidebar {\n  flex-basis: 200px;\n  border-bottom: 0 none;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.46);\n  z-index: 10;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.sidebar .wfm-sidebar-menu-container li {\n  border-left: 5px solid #B8C4CC;\n  padding-left: 16px;\n  line-height: 42px;\n}\n.sidebar .wfm-sidebar-menu-container li.nav-item {\n  background-color: #F2F5F7;\n  height: 44px;\n}\n.sidebar .wfm-sidebar-menu-container li.nav-item a {\n  padding-top: 0;\n  padding-bottom: 0;\n  color: #000000;\n}\n.sidebar .wfm-sidebar-menu-container li.nav-item a span {\n  margin-left: 10px;\n  display: inline-block;\n}\n.sidebar .wfm-sidebar-menu-container li.nav-item a.active svg {\n  fill: #008CCB;\n}\n.sidebar .wfm-sidebar-menu-container li.nav-item a.active .item-label {\n  color: #0094D1;\n}\n.sidebar.show-mini-sidebar {\n  flex-basis: 60px;\n}\n.sidebar.show-mini-sidebar .wfm-sidebar-menu-container li {\n  padding-left: 16px;\n}\n.sidebar.show-mini-sidebar .wfm-sidebar-menu-container li.nav-item .item-label {\n  display: none;\n}\n\n.top-bar {\n  background-image: linear-gradient(180deg, #009EDA, #007CBE);\n  padding: 0px 20px;\n  line-height: 34px;\n}\n.top-bar .app-name {\n  vertical-align: middle;\n  display: inline-block;\n  color: white;\n  font-size: 18px;\n  font-family: \"Open Sans Regular\", \"Helvetica Neue\", sans-serif;\n}\n\n.nav-item.show,\n.nav-item:hover {\n  background: #007fba;\n}\n\n.nav-item.dropdown {\n  font-size: 14px;\n}\n\n.dropdown-menu {\n  border-radius: 0;\n  margin-top: 0;\n  width: 180px;\n  padding: 2px 0 0 0;\n  border: 0;\n  font-size: 14px;\n  background: #006fa1;\n  color: #FFF;\n  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);\n}\n.dropdown-menu .dropdown-item {\n  background: #007fba;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.dropdown-menu .dropdown-item:hover {\n  background: #1C639C;\n}\n.dropdown-menu .dropdown-item.disabled {\n  color: lightgrey;\n  opacity: 0.65;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: #FFF;\n  padding-left: 21px;\n  padding-right: 37px;\n}\n.navbar-dark .navbar-nav .nav-link .dropdown-item:hover {\n  background: #1C639C;\n}\n\n.show.nav-item.dropdown {\n  width: 180px;\n}\n\n.show .dropdown-toggle {\n  text-align: left;\n}\n\n.dropdown-toggle span {\n  max-width: 122px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.dropdown-toggle::after {\n  vertical-align: middle;\n  border: 0;\n  font-size: 10px;\n  content: \"\\e919\";\n  font-family: \"icomoon\";\n  position: absolute;\n  top: 8px;\n  right: 20px;\n}\n\n.navbar-brand {\n  padding-left: 24px;\n}\n\n.app-content {\n  overflow: hidden;\n}\n\n.main-content {\n  background-color: #E1EAF2;\n  position: relative;\n  margin-left: 0px;\n}\n\n.with-top-bar .main-content {\n  padding-left: 230px;\n  padding-right: 0;\n  margin-left: 0;\n  transition: all 0.2s ease-in-out 0s;\n}\n\n.with-top-bar.show-mini-sidebar .main-content {\n  margin-left: 0px;\n  padding-left: 60px;\n  padding-right: 0;\n}\n\n.content-wrapper {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.content-wrapper.with-top-bar {\n  top: 50px;\n}\n\n.help-icon {\n  color: white;\n  font-size: 20px;\n  padding-top: 8px;\n  cursor: pointer;\n}\n\n.dropdown-user a {\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
